/**
 * `crypto.randomUUID` is only exposed in secure contexts (https, localhost).
 * The app is also served over plain http from an IP address, where the
 * browser leaves it undefined and any dependency calling it throws
 * "crypto.randomUUID is not a function".
 *
 * `crypto.getRandomValues` is NOT secure-context gated, so it stays available
 * and gives us a proper RFC 4122 v4 UUID on insecure origins too.
 */
if (typeof crypto !== 'undefined' && typeof crypto.randomUUID !== 'function') {
  Object.defineProperty(crypto, 'randomUUID', {
    configurable: true,
    writable: true,
    value: function randomUUID(): `${string}-${string}-${string}-${string}-${string}` {
      const bytes = new Uint8Array(16);
      crypto.getRandomValues(bytes);

      bytes[6] = (bytes[6] & 0x0f) | 0x40; // version 4
      bytes[8] = (bytes[8] & 0x3f) | 0x80; // variant 10

      const hex: string[] = [];
      for (let i = 0; i < 16; i++) {
        hex.push(bytes[i].toString(16).padStart(2, '0'));
      }

      return [
        hex.slice(0, 4).join(''),
        hex.slice(4, 6).join(''),
        hex.slice(6, 8).join(''),
        hex.slice(8, 10).join(''),
        hex.slice(10, 16).join(''),
      ].join('-') as `${string}-${string}-${string}-${string}-${string}`;
    },
  });
}
